module.exports = __webpack_public_path__ + "img/Icon-Social-Habits.168f42d8.svg";